import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { ModeProvider } from "context/ThemeContext";

const container = document.getElementById("root");
const root = createRoot(container);

// Only use StrictMode in development for debugging
const AppWithProvider = (
  <ModeProvider>
    <App />
  </ModeProvider>
);

root.render(
  process.env.MODE === "DEV" ? (
    <React.StrictMode>{AppWithProvider}</React.StrictMode>
  ) : (
    AppWithProvider
  )
);
